import { Button, Popover, Whisper, Divider } from "rsuite";
import styles from "./AttachedFiles.module.css";
import TrashIcon from "@rsuite/icons/Trash";
import AttachmentIcon from "@rsuite/icons/Attachment";
import FileUploaderModal from "./Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./Components/FileUploaderModal/useFileUploaderModal";
import { useInvoices } from "../../useInvoices";
import {
  isInvoiceAllowedToDelete,
  isInvoiceAllowedToAdd,
} from "../../../../../helperFunctions";
import PdfIconFile from "../../../../../Components/Icons/pdf.png";
import { useState } from "react";
import CloseIcon from "@rsuite/icons/Close";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import PdfPreview from "../../Components/PdfPreview/PdfPreview";

function AttachedFiles({ readonly }) {
  const { showFileUploaderModal } = useFileUploaderModal();
  const { form } = useInvoices.getState();
  const { deleteAttachedInvoice, processInvoice, processingInvoice } =
    useInvoices();

  const canAddFiles = isInvoiceAllowedToAdd();
  const canDeleteInvoice = isInvoiceAllowedToDelete(readonly);
  const pdfURL = form?.invoice_filename;

  const isInvoiceDisabledToProcess = (status) => {
    if (status == "OCR") return false;
    if (!status) return false;

    return true;
  };
  const isDisabledProcessInvoice = isInvoiceDisabledToProcess(
    form.invoice_status
  );
  if (isInvoiceDisabledToProcess(form.invoice_status)) readonly = false;

  const addFilesButton = (
    <Button
      disabled={readonly}
      onClick={showFileUploaderModal}
      color="blue"
      appearance="primary"
      style={{ width: 150 }}
    >
      Upload Invoice
    </Button>
  );

  const processButton = (
    <Button
      loading={processingInvoice}
      onClick={processInvoice}
      color="green"
      appearance="primary"
      style={{ width: 150 }}
      disabled={isDisabledProcessInvoice}
    >
      Process Invoice
    </Button>
  );

  return (
    <>
      <div className={styles.invoice_file_container}>
        <div className={styles.button_container}>
          {!pdfURL && canAddFiles && addFilesButton}
          {pdfURL && canAddFiles && processButton}
        </div>
        <div className={styles.files_container}>
          {pdfURL && (
            <>
              <File
                name={pdfURL}
                url={pdfURL}
                onDelete={() => {
                  deleteAttachedInvoice();
                }}
                readonly={readonly}
              />
            </>
          )}
        </div>
        {/* <div className={styles.process_invoice_button}>{canAddFiles && processButton}</div> */}
      </div>

      <FileUploaderModal />
    </>
  );
}

export default AttachedFiles;

const File = ({ name, url, onDelete, readonly }) => {
  const { handlepdfShow, handlepdfClose, ispdfShow } = useInvoices();

  const trashIcon = (
    <CloseIcon
      onClick={onDelete}
      style={{ color: "red", cursor: "pointer", width: "20px" }}
    />
  );

  const handleDownloadPdf = (e, pdfUrl) => {
    e.stopPropagation();

    if (pdfUrl) {
      // window.open(pdfUrl, '_blank');
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadIcon = (
    <FileDownloadIcon
      onClick={(e) => handleDownloadPdf(e, url)}
      style={{ fontSize: "14px", cursor: "pointer", width: "20px" }}
    />
  );
  const avaliableToDelete = isInvoiceAllowedToDelete(readonly);

  const tooltip = <Popover>{url}</Popover>;
  const PdfIcon = (
    <div
      onClick={() => handlepdfShow(url)}
      style={{
        width: 35,
        height: 40,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        transition: "0.5s",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.3)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <Whisper
        delay={300}
        placement="bottomStart"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          src={PdfIconFile}
          alt="View PDF"
          style={{ width: "100%", height: "100%" }}
        />
      </Whisper>
    </div>
  );

  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <div
        className={styles.file_container}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={styles.file_name}>{PdfIcon}</div>

        <div className={styles.file_delete}>
          {avaliableToDelete && isHovered && trashIcon}
        </div>
        <div className={styles.file_download}>{isHovered && downloadIcon}</div>
      </div>
      {url && <PdfPreview ispdfShow={ispdfShow} selectedPdf={url} />}
    </>
  );
};
